import React from "react";
import { Button, Flex, IconButton, Text } from "@chakra-ui/react";
import CustomIcon from "../../../../../../../public/icons-v1_1";

interface Props {
  year: number;
  month: number;
  isNextDisabled: boolean;
  onPrev: () => void;
  onNext: () => void;
  onToday: () => void;
}

function SettlementCalendarHeader({
  year,
  month,
  isNextDisabled,
  onPrev,
  onNext,
  onToday,
}: Props) {
  return (
    <Flex alignItems="center" gap="12px" mb="12px">
      <IconButton
        aria-label="이전 달"
        icon={<CustomIcon src={"caret-left"} width={24} height={24} />}
        variant="outline"
        color={"#8F8F8C"}
        padding={"2px"}
        boxShadow={"0 0 0 0.5px #8F8F8C"}
        border={"none"}
        background={"#FCFCFB"}
        borderRadius={"4px"}
        onClick={onPrev}
        size="auto"
        _hover={{
          background: "#FCFCFB",
          color: "#1272EF",
          boxShadow: "0 0 0 0.5px #1272EF",
        }}
      />
      <Text textStyle={"heading-sm"} color={"#444444"}>
        {year}년 {month}월
      </Text>
      <IconButton
        aria-label="다음 달"
        icon={<CustomIcon src={"caret-right"} width={24} height={24} />}
        variant="outline"
        color={"#8F8F8C"}
        border={"none"}
        padding={"2px"}
        boxShadow={"0 0 0 0.5px #8F8F8C"}
        background={"#FCFCFB"}
        borderRadius={"4px"}
        onClick={onNext}
        size="auto"
        isDisabled={isNextDisabled}
        _hover={{
          background: "#FCFCFB",
          color: "#1272EF",
          boxShadow: "0 0 0 0.5px #1272EF",
        }}
        _active={{
          background: "#FCFCFB",
          color: "#00417D",
          boxShadow: "0 0 0 0.5px #00417D",
        }}
        _disabled={{
          background: "#EFEFED",
          color: "#C0C0C0",
          borderColor: "#8F8F8C",
          cursor: "not-allowed",
        }}
      />
      <Button
        size="auto"
        variant="outline"
        padding={"4px 8px"}
        border={"none"}
        boxShadow={"0 0 0 0.5px #8F8F8C"}
        background={"#FCFCFB"}
        borderRadius={"4px"}
        onClick={onToday}
        marginLeft={"4px"}
        color={"#444444"}
        _hover={{
          background: "#FCFCFB",
          color: "#1272EF",
          boxShadow: "0 0 0 0.5px #1272EF",
        }}
        _active={{
          background: "#FCFCFB",
          color: "#00417D",
          boxShadow: "0 0 0 0.5px #00417D",
        }}
      >
        <Text textStyle={"body-sm-bold"}>오늘</Text>
      </Button>
    </Flex>
  );
}

export default SettlementCalendarHeader;
